import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../../../router';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Button, Checkbox, Form, FormField, Input, SegmentedControl, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { addDays } from 'date-fns';
import CurrencyInput from '../../../../../components/CurrencyInput';
import DPModal from '../../../../../components/DPModal';
import Favorites from '../../../../../components/extras/Favorites';
import SelectAccountPlan from '../../../../../components/selects/selectAccountPlans';
import SelectUser from '../../../../../components/selects/selectUser';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemsMovement } from '../../../../../resources/types';
import { addNotification, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';



export const AdminMovementsGeneratePage = () => {
    //const storeAdmin = useStoreAdmin();
    const { menu } = useGlobalState();

    const [movementType, setMovementType] = useState("");
    const [isInvalidMovement, setIsInvalidMovement] = useState(true);
    const [movement, setMovement] = useState<ItemsMovement>();
    useGlobalState();

    const { navigate } = useRouter();






    useEffect(() => {
        setMovement(prev => ({ ...(prev || {}), ammount: 0, idMovement: 0 } as ItemsMovement));
    }, []);

    useEffect(() => {
        let isInvalid = false;
        if (movement) {
            if (!movement.ammount) isInvalid = true;
            else if (movement.ammount <= 0) isInvalid = true;
            else if (!movement.idUser) isInvalid = true;
            else if (movement.idUser <= 0) isInvalid = true;
            else if (!movement.idAccountPlan) isInvalid = true;
            else if (movement.idAccountPlan <= 0) isInvalid = true;
            else if (!movement.dateTransaction) isInvalid = true;
            else if (movement.dateTransaction === "") isInvalid = true;
            else if (!movement.data) isInvalid = true;
            else if (movement.data === "") isInvalid = true;

        } else {
            isInvalid = true
        }
        setIsInvalidMovement(isInvalid)
    }, [movement]);
    const handleAddMovement = async () => {


        try {
            setLoading(true)

            let move = {
                ...movement,
                idMovement: 0,
                ammount: movementType === "charge" ? movement.ammount * -1 : movement.ammount,
                addReceipt: movementType === "credit" ? true : false
            }
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/update',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(move),
                //mode: 'no-cors'  // Bypasses CORS but limits the response
            });
            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            if (data.code == 0) {
                addNotification(data.status, 'info', setData);
                setMovement(undefined as ItemsMovement);
                setMovementType("");
            } else {
                addNotification(data.status, 'error', setData);
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones3: ${error.message}`, 'error', setData);
        } finally { setLoading(false) }
    }

    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}>Generar movimiento</Header>
                    <SegmentedControl
                        selectedId={movementType}
                        onChange={(event) => {
                            setMovementType(event.detail.selectedId)
                        }}
                        options={[
                            { text: "Abono", id: "credit" },
                            { text: "Cargo", id: "charge" },
                            { text: "Predefinido", id: "predefined" },
                        ]} label='Tipo de movimiento' />
                    <Form actions={
                        movementType !== "" && (
                            <Button disabled={isInvalidMovement}
                                onClick={() => {
                                    handleAddMovement();
                                }}
                                variant="primary">Generar {movementType === "credit" ? "abono" : ""}{movementType === "charge" ? "cargo" : ""}</Button>
                        )
                    }>
                        {movementType !== "" && (
                            <SpaceBetween size="s" direction='vertical'>
                                <SpaceBetween size="s" direction='horizontal'>
                                    <div style={{ width: 400 }}>
                                        <FormField label={"Usuario"}>
                                            <SelectUser value={movement?.idUser ?? 0} onConfirm={(user) => {
                                                setMovement(prev => ({ ...(prev || {}), idUser: user?.idUser } as ItemsMovement));
                                            }} />
                                        </FormField>
                                    </div>
                                    {movementType === "credit" && (
                                        <div style={{ width: 130 }}>
                                            <FormField label={"Folio"}>
                                                <Input value={movement?.receipt || "0"} readOnly />
                                            </FormField>
                                        </div>
                                    )}
                                </SpaceBetween>
                                <SpaceBetween size="s" direction='horizontal'>
                                    <div style={{ width: 200 }}>
                                        <FormField label={"Cuenta"}>
                                            <SelectAccountPlan
                                                filtering="auto"
                                                value={movement?.idAccountPlan ?? 0} onSelect={(idAccountPlan: number) => {
                                                    setMovement(prev => ({ ...(prev || {}), idAccountPlan: idAccountPlan } as ItemsMovement));
                                                }} />
                                        </FormField>
                                    </div>
                                    <FormField label={"Fecha contable"}>
                                        <DPModal
                                            date={movement?.dateTransaction || ""}
                                            clear={true}
                                            close={true}
                                            end={new Date()}
                                            start={addDays(new Date(), -14)}
                                            today
                                            onConfirm={(date) => {
                                                setMovement(prev => ({ ...(prev || {}), dateTransaction: (date) } as ItemsMovement));
                                            }}

                                        />
                                    </FormField>
                                    <FormField label={"Monto"}>

                                        <CurrencyInput value={movement?.ammount}
                                            onChange={(value) => {
                                                setMovement(prev => ({ ...(prev || {}), ammount: Number(value) } as ItemsMovement));
                                            }} />
                                    </FormField>
                                </SpaceBetween>
                                <FormField label={"Concepto"}>
                                    <Input value={movement?.data || ""} onChange={(detail) => {
                                        setMovement(prev => ({ ...(prev || {}), data: detail.detail.value } as ItemsMovement));
                                    }} />
                                </FormField>
                                <FormField label={"Observaciones"}>
                                    <Input value={movement?.obs || ""} onChange={(detail) => {
                                        setMovement(prev => ({ ...(prev || {}), obs: detail.detail.value } as ItemsMovement));
                                    }} />
                                </FormField>
                                <Checkbox checked={movement?.notify ? true : false} onChange={(e) => {
                                    setMovement(prev => ({ ...(prev || {}), notify: e.detail.checked } as ItemsMovement));
                                }}>Notificar al usuario</Checkbox>
                            </SpaceBetween>
                        )}
                    </Form>

                </SpaceBetween>
            }
        />
    );
};
